/**
 * Workflow Domain Constants
 * Single source of truth for workflow-related constants
 */

// Node categories used in workflow builder
export const NODE_CATEGORIES = {
  START: 'Start',
  END: 'End',
  SUBMISSION: 'Submission',
  REVIEW: 'Review',
  ASSESSMENT_REVIEW: 'Assessment Review',
  STAGE: 'Stage',
  CHILD_APP: 'child-app',
  CHILD_SBK: 'child-sbk',
  CHILD_REJ: 'child-rej',
  CHILD_STA: 'child-sta',
};

// Node types used in ReactFlow
export const NODE_TYPES = {
  INPUT: 'input',
  OUTPUT: 'output',
  FORM_STAGE: 'FormStage',
};

// Stage type IDs (matching database values)
export const STAGE_TYPE_IDS = {
  SUBMISSION: 1,
  REVIEW: 3,
};

// Stage type names
export const STAGE_TYPES = {
  SUBMISSION: 'Submission',
  REVIEW: 'Review',
  ASSESSMENT_REVIEW: 'Assessment Review',
};

// Approval type codes
export const APPROVAL_TYPE_CODES = {
  APPROVED: 'app',
  REJECTED: 'rej',
  SEND_BACK: 'sbk',
  SEND_TO_ASSESSMENT: 'sta',
};

// Approval type IDs (matching database values)
export const APPROVAL_TYPE_IDS = {
  APPROVED: 1,
  REJECTED: 2,
  SEND_BACK: 3,
  SEND_TO_ASSESSMENT: 4,
};

// Maps approval type IDs to request action codes (values match REQUEST_ACTIONS)
export const APPROVAL_TYPE_TO_ACTION = {
  [APPROVAL_TYPE_IDS.SEND_BACK]: 'sendback',
  [APPROVAL_TYPE_IDS.APPROVED]: 'approved',
  [APPROVAL_TYPE_IDS.REJECTED]: 'rejected',
  [APPROVAL_TYPE_IDS.SEND_TO_ASSESSMENT]: 'send_to_assessment',
};

// Valid target node categories for approval nodes
export const VALID_APPROVAL_TARGETS = [
  NODE_CATEGORIES.END,
  NODE_CATEGORIES.SUBMISSION,
  NODE_CATEGORIES.REVIEW,
];

// Valid target node categories for send back nodes
export const VALID_SEND_BACK_TARGETS = [
  NODE_CATEGORIES.SUBMISSION,
  NODE_CATEGORIES.REVIEW,
];

// Default workflow builder values
export const WORKFLOW_DEFAULTS = {
  START_NODE_ID: 'start',
  EDGE_STYLE: { stroke: '#2f80ed', strokeWidth: 2 },
  EDGE_TYPE: 'smoothstep',
  BACKGROUND_COLOR: '#99b3ec',
  BACKGROUND_VARIANT: 'Lines',
};

// Multi-form submission action types for useReducer
export const MULTI_FORM_ACTIONS = {
  SET_FORMS: 'SET_FORMS',
  SET_ACTIVE_FORM: 'SET_ACTIVE_FORM',
  SET_ACTIVE_SUBFORM: 'SET_ACTIVE_SUBFORM',
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  RESET: 'RESET',
};
